module.exports = __webpack_public_path__ + "img/ages.1a327c4e.svg";